module.exports = __webpack_public_path__ + "static/media/smallthumbsup.3849c32b.svg";